import { useContext } from 'react';
import { SearchContext } from '../contexts/complexContexts';

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within SearchProvider');
  }
  return context;
};

export const useSearchContext = useSearch;